export const vehicleSyntheticReportInitialValues = {
    agrupamento: 1, // operador
    deUtilizacao: '',
    usuarios: [],
    situacaoVeiculos: 1, // ativos
    subSistemas: [],
    tiposEmpresa: [],
    tiposPessoaFisica: [],
    tiposVeiculo: [],
    placas: [],
};
